import { useState } from 'react';
import { Mail, Phone, Briefcase, Calendar, User, ChevronRight, ChevronLeft, Linkedin, MapPin, GraduationCap } from 'lucide-react';
import { toast } from 'react-toastify';
import { getFirstEmail, getAllEmails } from '../../utils/emailHelpers';

// Fonction pour extraire les initiales du nom complet
const getInitials = (fullName) => {
    if (!fullName) return '?';
    const parts = fullName.trim().split(' ');
    if (parts.length === 1) return parts[0].charAt(0).toUpperCase();
    return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
};

const RecruitmentListView = ({
    candidatesByStage,
    recruitmentSteps,
    selectedCandidates,
    onSelectCandidate,
    onNavigateToIndividual,
    columnFilters,
    getFilteredCandidates,
    onMoveToNextStage,
    onRefresh
}) => {

    console.log(candidatesByStage);
    console.log(recruitmentSteps);
    const [activeTab, setActiveTab] = useState(recruitmentSteps[0]?._id || null);

    const currentStep = recruitmentSteps.find(step => step._id === activeTab);
    const currentStepIndex = recruitmentSteps.findIndex(step => step._id === activeTab);
    const nextStep = currentStepIndex >= 0 && currentStepIndex < recruitmentSteps.length - 1
        ? recruitmentSteps[currentStepIndex + 1]
        : null;
    const previousStep = currentStepIndex > 0
        ? recruitmentSteps[currentStepIndex - 1]
        : null;
    const allCandidates = candidatesByStage[activeTab] || [];
    const filteredCandidates = getFilteredCandidates ? getFilteredCandidates(activeTab, allCandidates) : allCandidates;
    const handleCandidateClick = (candidateId) => {
        if (onNavigateToIndividual) {
            onNavigateToIndividual(candidateId);
        }
    };

    const handleCheckboxClick = (e, candidateId) => {
        e.stopPropagation();
        if (onSelectCandidate) {
            onSelectCandidate(candidateId);
        }
    };

    const handleMoveToNextStage = async (e, candidateId) => {
        e.stopPropagation();
        if (onMoveToNextStage && nextStep) {
            try {
                await onMoveToNextStage(candidateId, nextStep._id);
                toast.success(`Candidat déplacé vers ${nextStep.name} avec succès`);
                if (onRefresh) {
                    onRefresh();
                }
            } catch (error) {
                console.error('Error moving candidate:', error);
                toast.error('Erreur lors du déplacement du candidat');
            }
        }
    };

    const handleMoveToPreviousStage = async (e, candidateId) => {
        e.stopPropagation();
        if (onMoveToNextStage && previousStep) {
            try {
                await onMoveToNextStage(candidateId, previousStep._id);
                toast.success(`Candidat déplacé vers ${previousStep.name} avec succès`);
                if (onRefresh) {
                    onRefresh();
                }
            } catch (error) {
                console.error('Error moving candidate:', error);
                toast.error('Erreur lors du déplacement du candidat');
            }
        }
    };

  return (
    <div className='bg-white rounded-lg border'>
        {/* Onglets */}
        <div className='border-b overflow-x-auto rounded-t-lg'>
            <div className=' flex min-w-max '>
            {recruitmentSteps.map((step) => {
                const stepCandidates = candidatesByStage[step._id] || [];
                const isActive = activeTab === step._id;

                return (
                    <button
                        key={step._id}
                        onClick={() => {setActiveTab(step._id)}}
                        className={`px-6 py-3 text-sm font-medium border-b-2 transition-colors whitespace-nowrap 
                            ${isActive ? 'border-blue-600 text-blue-600 bg-blue-50 ' : 'border-transparent text-gray-600 hover:text-gray-900 hover:bg-gray- 50'} `}
                    >
                        <div className='flex items-center space-x-2'>
                            <span>{step.name}</span>
                            <span className={`px-2 py-0.5 rounded-full text-xs ${isActive ? 'bg-blue-100 text-blue-700' : 'bg-gray-100 text-gray-600'}`}>
                                {stepCandidates.length}
                            </span>
                        </div>
                    </button>
                );
            })}
            </div>
        </div>
        
        {/* En-tête avec checkbox de sélection globale */}
        {filteredCandidates.length > 0 && (
            <div className='px-4 py-3 bg-gray-50 border-b flex items-center'>
                <input
                    type="checkbox"
                    checked={filteredCandidates.length > 0 && filteredCandidates.every(candidate => selectedCandidates.includes(candidate._id))}
                    onChange={(e) => {
                        const allCandidateIds = filteredCandidates.map(c => c._id);
                        if (e.target.checked) {
                            // Ajouter tous les candidats de l'étape
                            onSelectCandidate && allCandidateIds.forEach(id => {
                                if (!selectedCandidates.includes(id)) {
                                    onSelectCandidate(id);
                                }
                            });
                        } else {
                            // Désélectionner tous les candidats de l'étape
                            allCandidateIds.forEach(id => {
                                if (selectedCandidates.includes(id)) {
                                    onSelectCandidate(id);
                                }
                            });
                        }
                    }}
                    className="h-5 w-5 text-blue-600 rounded border-gray-300 focus:ring-blue-500"
                />
                <span className='ml-3 text-sm text-gray-600 font-medium'>
                    Sélectionner tous les candidats ({filteredCandidates.length})
                </span>
            </div>
        )}

        {/* Liste des candidats */}
        <div className='divide-y'>
            {filteredCandidates.length === 0 ? (
                <div className='p-12 text-center'>
                    <User className='mx-auto h-12 w-12 text-gray-400 mb-4 '/>
                    <p className='text-gray-600'>Aucun candidat dans cette étape</p>
                </div>
            ) : (
                filteredCandidates.map((candidate) => {
                    const individual = candidate.individual;
                    const isSelected = selectedCandidates.includes(candidate._id);

                    return (
                        <div
                            key={candidate._id}
                            className={`p-4 hover:bg-gray-50 transition-colors ${
                                isSelected ? 'bg-blue-50' : ''
                            }`}
                        >
                            <div className="flex items-center space-x-4">
                                {/* Checkbox */}
                                <div onClick={(e) => e.stopPropagation()}>
                                    <input
                                        type="checkbox"
                                        checked={isSelected}
                                        onChange={(e) => handleCheckboxClick(e, candidate._id)}
                                        className="h-5 w-5 text-blue-600 rounded border-gray-300 focus:ring-blue-500"
                                    />
                                </div>

                                {/* Reste de la ligne - cliquable */}
                                <div
                                    onClick={() => handleCandidateClick(individual?._id)}
                                    className="flex items-center space-x-4 flex-1 cursor-pointer"
                                >
                                    {/* Photo de profil */}
                                    <div className="flex-shrink-0">
                                    {individual?.photo ? (
                                        <img
                                            src={individual.photo}
                                            alt={individual?.Name}
                                            className="h-12 w-12 rounded-full object-cover"
                                        />
                                    ) : (
                                        <div className="h-12 w-12 rounded-full bg-gradient-to-br from-blue-500 to-purple-600 flex items-center justify-center">
                                            <span className="text-white font-semibold text-base">
                                                {getInitials(individual?.Name || individual?.name)}
                                            </span>
                                        </div>
                                    )}
                                </div>

                                {/* Informations principales */}
                                <div className="flex-1 min-w-0">
                                    {/* Nom avec LinkedIn */}
                                    <div className="flex items-center space-x-2 mb-1">
                                        <h3 className="text-sm font-semibold text-blue-600 truncate mb-0">
                                            {individual?.Name || 'Nom inconnu'}
                                        </h3>
                                        {individual?.linkedinUrl && (
                                            <a
                                                href={individual.linkedinUrl}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                onClick={(e) => e.stopPropagation()}
                                                className="text-blue-600 hover:text-blue-800 transition-colors"
                                            >
                                                <Linkedin size={14} />
                                            </a>
                                        )}
                                    </div>

                                    {/* JobTitle et Company */}
                                    {(individual?.jobTitle || individual?.company) && (
                                        <div className="flex items-center space-x-1.5 text-xs mb-1">
                                            {individual?.jobTitle && (
                                                <span className="font-semibold text-gray-900 truncate max-w-[250px]">
                                                    {individual.jobTitle}
                                                </span>
                                            )}
                                            {individual?.jobTitle && individual?.company && (
                                                <span className="text-gray-400">-</span>
                                            )}
                                            {individual?.company && (
                                                <span className="text-gray-600 truncate">
                                                    {individual.company}
                                                </span>
                                            )}
                                        </div>
                                    )}

                                    {/* Description */}
                                    {individual?.description && (
                                        <div className="text-xs text-gray-600 mb-1 line-clamp-2 max-w-[500px]">
                                            {individual.description}
                                        </div>
                                    )}

                                    {/* Emails - sur une ligne dédiée */}
                                    {(getAllEmails(individual?.professionalEmail).length > 0 || getAllEmails(individual?.personalEmail).length > 0) && (
                                        <div className="flex items-center space-x-3 text-xs mb-1">
                                            {getAllEmails(individual?.professionalEmail).length > 0 && (
                                                <div className="flex items-center space-x-1">
                                                    <Mail size={11} className="text-blue-500" />
                                                    <span className="truncate max-w-[180px]">
                                                        {getFirstEmail(individual.professionalEmail)}
                                                    </span>
                                                </div>
                                            )}
                                            {getAllEmails(individual?.personalEmail).length > 0 && (
                                                <div className="flex items-center space-x-1">
                                                    <Mail size={11} className="text-green-500" />
                                                    <span className="truncate max-w-[180px]">
                                                        {getFirstEmail(individual.personalEmail)}
                                                    </span>
                                                </div>
                                            )}
                                        </div>
                                    )}

                                    {/* Téléphone - sur sa propre ligne */}
                                    {individual?.phoneNumber &&
                                     individual.phoneNumber !== '-' &&
                                     individual.phoneNumber.toLowerCase() !== 'téléphone indisponible' && (
                                        <div className="flex items-center space-x-1 text-xs mb-1">
                                            <Phone size={11} className="text-gray-400" />
                                            <span>{individual.phoneNumber}</span>
                                        </div>
                                    )}

                                    {/* Autres informations */}
                                    <div className="flex flex-wrap gap-2 text-xs text-gray-600">
                                        {/* Ville */}
                                        {individual?.city && (
                                            <div className="flex items-center space-x-1">
                                                <MapPin size={11} className="text-gray-400" />
                                                <span>{individual.city.split(',')[0].trim()}</span>
                                            </div>
                                        )}

                                        {/* Formation */}
                                        {individual?.formation && (
                                            <div className="flex items-center space-x-1">
                                                <GraduationCap size={11} className="text-gray-400" />
                                                <span className="truncate max-w-[200px]">{individual.formation}</span>
                                            </div>
                                        )}
                                    </div>

                                    {/* Tags */}
                                    {candidate.tags && candidate.tags.length > 0 && (
                                        <div className="flex flex-wrap gap-1 mt-2">
                                            {candidate.tags.slice(0, 3).map((tag, idx) => (
                                                <span
                                                    key={idx}
                                                    className="px-2 py-0.5 bg-blue-100 text-blue-700 text-xs rounded-full"
                                                >
                                                    {tag.name}
                                                </span>
                                            ))}
                                            {candidate.tags.length > 3 && (
                                                <span className="text-xs text-gray-500 py-0.5">
                                                    +{candidate.tags.length - 3}
                                                </span>
                                            )}
                                        </div>
                                    )}
                                </div>

                                    {/* Boutons de navigation et badge de l'étape */}
                                    <div className="flex-shrink-0 flex items-center space-x-2">
                                        {previousStep && (
                                            <button
                                                onClick={(e) => handleMoveToPreviousStage(e, candidate._id)}
                                                className="p-1.5 bg-gray-500 hover:bg-gray-600 text-white rounded-full transition-colors"
                                                title={`Retour à ${previousStep.name}`}
                                            >
                                                <ChevronLeft size={14} />
                                            </button>
                                        )}
                                        <span className="px-3 py-1 rounded-full text-xs font-medium bg-gray-100 text-gray-700">
                                            {currentStep?.name || 'N/A'}
                                        </span>
                                        {nextStep && (
                                            <button
                                                onClick={(e) => handleMoveToNextStage(e, candidate._id)}
                                                className="p-1.5 bg-blue-600 hover:bg-blue-700 text-white rounded-full transition-colors"
                                                title={`Passer à ${nextStep.name}`}
                                            >
                                                <ChevronRight size={14} />
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </div>

                            {/* Notes si présentes */}
                            {candidate.notes && candidate.notes.length > 0 && (
                                <div className="mt-3 ml-16 text-xs text-gray-600 bg-yellow-50 p-2 rounded border-l-2 border-yellow-400">
                                    <p className="line-clamp-2">{candidate.notes[candidate.notes.length - 1]}</p>
                                </div>
                            )}
                        </div>
                    )
                })
            )}
        </div>

        {/* Footer avec statistiques */}
        {filteredCandidates.length > 0 && (
            <div className="px-6 py-3 bg-gray-50 border-t text-sm text-gray-600">
                Affichage de {filteredCandidates.length} candidat(s) sur {allCandidates.length}
                {selectedCandidates.length > 0 && (
                    <span className="ml-4 text-blue-600 font-medium">
                        {selectedCandidates.length} sélectionné(s)
                    </span>
                )}
            </div>
        )}
    </div>
  )
}

export default RecruitmentListView